import { FC } from 'react';

// Third-party
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid2';

// Types
import { TSettingsHeader } from '../type';

const SettingsHeader: FC<TSettingsHeader> = ({ title, subtitle }) => (
  <Grid>
    <Grid>
      <Typography variant="h5">
        {title}
      </Typography>
    </Grid>
    <Grid paddingTop={1}>
      <Typography
        variant="body2"
        sx={{
          color: 'text.secondary',
        }}
      >
        {subtitle}
      </Typography>
    </Grid>
  </Grid>
);

export {
  SettingsHeader,
};
